import React, { ReactElement, useContext, useEffect, useState } from "react";
import { NavContext } from "./navContext";
import { NavTreeActionType } from "./navReducer.types";
import { renderMenuItem } from "./panel-menu-standalone";

/**
 * A component whose sole purpose is to measure the width of all primary nav
 * items before deciding whether they belong to the "visible" or "show more"
 * container. The component is mounted only on initial render and when props
 * schema change (e.g. nav items added/removed or new className added)
 * and only for the time of measurement. It is then removed from the DOM.
 */
export const HeaderMeasureHelper = (): ReactElement | null => {
  const { state, dispatch } = useContext(NavContext);
  const [element, setElement] = useState<HTMLSpanElement | null>(null);

  useEffect(() => {
    if (element) {
      const navItemsWidth = Array.from(
        element.querySelectorAll(".spark-menu__list-item.top-level-item")
      ).map((item) => item?.clientWidth ?? 0);

      dispatch({
        type: NavTreeActionType.SET_ITEMS_WIDTH,
        navItemsWidth,
      });
    }
  }, [dispatch, element]);

  return (
    <ul
      ref={(node): void => {
        if (node && node?.clientHeight > 0) {
          setElement(node);
        }
      }}
      style={{
        overflow: "hidden",
        visibility: "hidden",
      }}
      className="spark-menu__list spark-header__list spark-header__list--overflow header-measuring"
    >
      {state.navTree?.map((item) => renderMenuItem(item, true, false))}
    </ul>
  );
};

HeaderMeasureHelper.displayName = "HeaderMeasureHelper";
